import { useUserStore } from "@/stores/UserStore";

// "Sayfa Yönetimi"nde tanımlı sayfa/eylem yetkisini denetler (menü, router ve sayfa içi butonlarla aynı kural):
// kayıt, kullanıcının yetki listesinde bulunmalı ve yetkisi "Unauthorized" olmamalıdır.
// path: "micro/keys", "/micro/keys/delete" ya da menü biçimi "/#/micro/keys" olabilir.
export const normalizePagePath = (path) =>
  String(path || "")
    .replace(/^\/#\//, "")
    .replace(/^\//, "")
    .toLowerCase();

export const hasPageAuth = (path) => {
  const target = normalizePagePath(path);
  if (!target) return false;
  const list = useUserStore().getAllUserAuth || [];
  return list.some((t) => {
    if (!t || !t.page || !t.page.path || !t.permissions) return false;
    return (
      normalizePagePath(t.page.path) === target &&
      t.permissions.permissionName !== "Unauthorized"
    );
  });
};
